import { Bar } from "react-chartjs-2"
import ChartDataLabels from "chartjs-plugin-datalabels"
import React from "react"
import { Grid2, Typography } from "@mui/material"
import { getGraphStyles } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/graph-styles"

export function AnalysisBar({ data, title, options = { fullwidth: false } }) {
    const { size, graphGridSx } = getGraphStyles(options)

    return (
        <Grid2 size={size} sx={graphGridSx}>
            <Bar
                data={data}
                plugins={[ChartDataLabels]}
                options={{
                    layout: {
                        padding: {
                            top: 20, // or more if needed
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false, // usually not needed for bar charts
                        },
                        datalabels: {
                            anchor: "end",
                            align: "top",
                            formatter: (value) => value,
                            color: "#444",
                            font: {
                                weight: "bold",
                            },
                        },
                    },
                    scales: {
                        x: {
                            ticks: {
                                autoSkip: false,
                                minRotation: 70,
                                maxRotation: 70,
                            },
                        },
                        y: {
                            beginAtZero: true,
                        },
                    },
                }}
            />
            <Typography mt={2} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                {title}
            </Typography>
        </Grid2>
    )
}
